"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
// @ts-nocheck

var pwc_deals_ui_1 = require("@pwc/pwc-deals-ui");

var fast_equals_1 = require("fast-equals");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var reportlivepreviewService_1 = require("../../services/reportlivepreviewService");

require("./index.css");

var provider_1 = require("./provider");

var ReportPreviewItem_1 = __importDefault(require("./ReportPreviewItem")); // @ts-ignore


var ReportPreview = function (_a) {
  var errorHandlerRef = _a.errorHandlerRef;

  var _b = (0, react_1.useState)(false),
      loading = _b[0],
      setLoading = _b[1];

  var liveReportPreview = (0, provider_1.useLiveReportPreview)();
  var // @ts-ignore
  getProjectId = liveReportPreview.getProjectId,
      // @ts-ignore
  getReportPreviewPropsSelector = liveReportPreview.getReportPreviewPropsSelector,
      // @ts-ignore
  setReportPreviewProps = liveReportPreview.setReportPreviewProps,
      // @ts-ignore
  useTabletOrMobile = liveReportPreview.useTabletOrMobile;
  var projectId = (0, react_redux_1.useSelector)(getProjectId);

  var _c = (0, react_1.useState)([]),
      pages = _c[0],
      setPages = _c[1];

  var _d = (0, react_1.useState)(undefined),
      lastData = _d[0],
      setLastData = _d[1];

  var params = (0, react_redux_1.useSelector)(getReportPreviewPropsSelector);
  var dispatch = (0, react_redux_1.useDispatch)();
  var isTabletOrMobile = useTabletOrMobile();

  var _e = errorHandlerRef || {},
      errorHandler = _e.errorHandler,
      clearError = _e.clearError;

  var getBase64Image = function (imgUrl, callback) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = function () {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        var dataUrl = canvas.toDataURL();
        resolve(callback(dataUrl));
      };

      img.src = imgUrl;
    });
  };

  var updateFigureStyle = function (data) {
    var htmlObject = document.createElement('div');
    htmlObject.innerHTML = data;
    var element = htmlObject.firstChild;
    var figureElement = htmlObject.querySelector('figure');
    var imgElement = element.querySelector('img');

    if (figureElement && imgElement) {
      var val = figureElement.getAttribute('style');

      if (val) {
        imgElement.setAttribute('style', val);
        figureElement.removeAttribute('style');
      }
    }

    return figureElement.outerHTML;
  };

  var getFiguresWithBase64Images = function (richTextData) {
    return __awaiter(void 0, void 0, void 0, function () {
      var figures, figureStyles, figuresWithSpan, allFigureElements, _i, allFigureElements_1, figure, newFigure, allImgElements, _loop_1, _a, allImgElements_1, image, state_1;

      var _b, _c, _d, _e;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            figures = [];
            figureStyles = [];
            figuresWithSpan = richTextData === null || richTextData === void 0 ? void 0 : richTextData.match(/<span class="image-inline.*?<\/span>/g);
            richTextData = richTextData.replace(/<span class="image-inline.*?<\/span>/g, function (i) {
              return function (_) {
                return figuresWithSpan[i++].replace(/<span/g, '<figure').replace(/<\/span>/g, '</figure>');
              };
            }(0));
            if (!(richTextData && richTextData.includes('<img'))) return [3
            /*break*/
            , 4];
            allFigureElements = richTextData === null || richTextData === void 0 ? void 0 : richTextData.match(/<f.*?<\/figure>/g);

            if ((allFigureElements === null || allFigureElements === void 0 ? void 0 : allFigureElements.length) > 0) {
              for (_i = 0, allFigureElements_1 = allFigureElements; _i < allFigureElements_1.length; _i++) {
                figure = allFigureElements_1[_i];

                if (figure && figure.includes('<img')) {
                  newFigure = updateFigureStyle(figure);
                  figureStyles.push(newFigure);
                } else {
                  figureStyles.push(figure);
                }
              }
            }

            if (richTextData.includes('<figure')) richTextData = richTextData.replace(/<f.*?<\/figure>/g, function (i) {
              return function (_) {
                return figureStyles[i++];
              };
            }(0));
            allImgElements = richTextData === null || richTextData === void 0 ? void 0 : richTextData.match(/<img.*?>/g);
            if (!((allImgElements === null || allImgElements === void 0 ? void 0 : allImgElements.length) > 0)) return [3
            /*break*/
            , 4];

            _loop_1 = function (image) {
              var imageUrlSrcsplit, imageUrlSplit, imageUrlSplit1, imageUrlSplit2, imageUrlSplit3, imageUrl, e_1;
              return __generator(this, function (_g) {
                switch (_g.label) {
                  case 0:
                    imageUrlSrcsplit = image === null || image === void 0 ? void 0 : image.split('src=');
                    imageUrlSplit = (_b = imageUrlSrcsplit === null || imageUrlSrcsplit === void 0 ? void 0 : imageUrlSrcsplit[1]) === null || _b === void 0 ? void 0 : _b.split('/>');
                    imageUrlSplit1 = (_c = imageUrlSplit === null || imageUrlSplit === void 0 ? void 0 : imageUrlSplit[0]) === null || _c === void 0 ? void 0 : _c.split('>');
                    imageUrlSplit2 = (_d = imageUrlSplit1 === null || imageUrlSplit1 === void 0 ? void 0 : imageUrlSplit1[0]) === null || _d === void 0 ? void 0 : _d.match(/.*?"/g);
                    imageUrlSplit3 = (_e = imageUrlSplit2 === null || imageUrlSplit2 === void 0 ? void 0 : imageUrlSplit2[1]) === null || _e === void 0 ? void 0 : _e.split('"');
                    imageUrl = imageUrlSplit3 === null || imageUrlSplit3 === void 0 ? void 0 : imageUrlSplit3[0];
                    _g.label = 1;

                  case 1:
                    _g.trys.push([1, 3,, 4]);

                    return [4
                    /*yield*/
                    , getBase64Image(imageUrl, function (base64Image) {
                      var fig = image === null || image === void 0 ? void 0 : image.replace(/src=".*?"/, "src=".concat(base64Image));

                      if (fig) {
                        figures.push(fig);
                      }
                    })];

                  case 2:
                    _g.sent();

                    return [3
                    /*break*/
                    , 4];

                  case 3:
                    e_1 = _g.sent(); // eslint-disable-next-line no-console

                    console.log('Error retrieving base64 image', e_1);
                    return [2
                    /*return*/
                    , {
                      value: e_1
                    }];

                  case 4:
                    return [2
                    /*return*/
                    ];
                }
              });
            };

            _a = 0, allImgElements_1 = allImgElements;
            _f.label = 1;

          case 1:
            if (!(_a < allImgElements_1.length)) return [3
            /*break*/
            , 4];
            image = allImgElements_1[_a];
            return [5
            /*yield**/
            , _loop_1(image)];

          case 2:
            state_1 = _f.sent();
            if (typeof state_1 === "object") return [2
            /*return*/
            , state_1.value];
            _f.label = 3;

          case 3:
            _a++;
            return [3
            /*break*/
            , 1];

          case 4:
            if (figures && figures.length > 0) {
              richTextData = richTextData.replace(/<img.*?>/g, function (i) {
                return function (_) {
                  return figures[i++];
                };
              }(0));
            }

            return [2
            /*return*/
            , Promise.resolve(richTextData)];
        }
      });
    });
  };

  var loadReportImages = function (convertedAnalysis) {
    return __awaiter(void 0, void 0, void 0, function () {
      var type, realData, _i, _a, item, _b, response, reportImages, e_2;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            setLoading(true);
            _c.label = 1;

          case 1:
            _c.trys.push([1, 7, 8, 9]);

            type = convertedAnalysis.type, realData = __rest(convertedAnalysis, ["type"]);
            if (!(realData && realData.content && realData.content.parts && realData.content.parts.length > 0)) return [3
            /*break*/
            , 5];
            _i = 0, _a = realData.content.parts;
            _c.label = 2;

          case 2:
            if (!(_i < _a.length)) return [3
            /*break*/
            , 5];
            item = _a[_i];
            if (!(item && item.data && item.data.includes('<img'))) return [3
            /*break*/
            , 4];
            _b = item;
            return [4
            /*yield*/
            , getFiguresWithBase64Images(item.data)];

          case 3:
            _b.data = _c.sent();
            _c.label = 4;

          case 4:
            _i++;
            return [3
            /*break*/
            , 2];

          case 5:
            return [4
            /*yield*/
            , (0, reportlivepreviewService_1.getReportLiveReportPreview)(projectId, realData, type)];

          case 6:
            response = _c.sent();
            reportImages = response.previewImage.map(function (pImage, index) {
              return {
                uniqueKey: "key-".concat(index + 1),
                src: pImage,
                name: "Report ".concat(index + 1),
                supportHover: false
              };
            });
            setPages(reportImages);

            if (clearError) {
              clearError();
            }

            return [3
            /*break*/
            , 9];

          case 7:
            e_2 = _c.sent();

            if (errorHandler) {
              errorHandler(e_2);
            }

            return [3
            /*break*/
            , 9];

          case 8:
            setLoading(false);
            return [7
            /*endfinally*/
            ];

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var compareData = function () {
    // @ts-ignore
    if (!params || params === {} || !liveReportPreview.getData) return {}; // @ts-ignore

    var currentData = liveReportPreview.getData();
    var comparisonData = lastData; // @ts-ignore

    var isDirty = params.isDirty || !(0, fast_equals_1.deepEqual)(currentData, comparisonData); // @ts-ignore

    if (params.isDirty) {
      dispatch(setReportPreviewProps({
        isDirty: false
      }));
    }

    return {
      isDirty: isDirty,
      currentData: currentData,
      comparisonData: comparisonData
    };
  };

  var doIntervalLoadImages = function () {
    var _a = compareData(),
        isDirty = _a.isDirty,
        currentData = _a.currentData;

    if (isDirty) {
      // @ts-ignore
      var convertedAnalysis = liveReportPreview.getPayload();
      loadReportImages(convertedAnalysis);
      setLastData(currentData);
    }
  };

  (0, react_1.useEffect)(function () {
    var intervalId = setInterval(function () {
      doIntervalLoadImages();
    }, 5000);
    return function () {
      return clearInterval(intervalId);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadReportImages]);
  (0, react_1.useEffect)(function () {
    doIntervalLoadImages();
  }, []);
  return react_1.default.createElement("div", {
    className: "live-report-preview"
  }, loading && react_1.default.createElement(pwc_deals_ui_1.Loader, {
    className: isTabletOrMobile ? 'small' : '',
    "data-testid": "live-report-preview-loader"
  }), !loading && pages.map(function (reportPage) {
    var uniqueKey = reportPage.uniqueKey,
        src = reportPage.src,
        name = reportPage.name;
    return react_1.default.createElement(ReportPreviewItem_1.default, {
      key: uniqueKey,
      uniqueKey: uniqueKey,
      src: src,
      name: name,
      supportHover: false
    });
  }));
};

exports.default = ReportPreview;